import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getTruong(payload: {
  page: number;
  limit: number;
  cond?: any;
  organizationId?: string;
  filterInfo?: object;
}) {
  const { page, limit, cond, organizationId } = payload;
  // eslint-disable-next-line no-underscore-dangle
  if (cond?._id === 'Tất cả') delete cond?._id;
  if (organizationId) {
    return axios.get(`${ip3}/don-vi/pageable`, {
      params: {
        page,
        limit,
        cond: {
          loaiDonVi: 'Truong',
          ...cond,
          _id: organizationId,
        },
        ...(payload?.filterInfo?.sort && {
          sort: {
            ...payload?.filterInfo?.sort,
          },
        }),
      },
    });
  }
  return axios.get(`${ip3}/don-vi/pageable`, {
    params: {
      page,
      limit,
      cond: {
        loaiDonVi: 'Truong',
        ...cond,
      },
      ...(payload?.filterInfo?.sort && {
        sort: {
          ...payload?.filterInfo?.sort,
        },
      }),
    },
  });
}

export async function addTruong(payload: any) {
  return axios.post(`${ip3}/don-vi`, payload);
}
export async function getThucDonCuoi(payload: { id: string; dieuChinh: boolean }) {
  return axios.get(`${ip3}/khau-phan-an/${payload.id}/thuc-don-cuoi-cung`, {
    params: {
      dieuChinh: payload.dieuChinh,
    },
  });
}
export async function getRoleBySystemRole(payload: { page: number; limit: number; systemRole: string }) {
  return axios.get(`${ip3}/roles/pageable`, {
    params: {
      page: payload.page,
      limit: payload.limit,
      cond: {
        systemRole: payload.systemRole,
      },
    },
  });
}
export async function addThongTinHocPhiTruong(payload: any) {
  return axios.post(`${ip3}/thong-tin-hoc-phi-truong`, payload);
}

export async function updThongTinHocPhiTruong(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/thong-tin-hoc-phi-truong/${id}`, payload);
}
export async function updTruong(payload: any) {
  const { id } = payload;
  delete payload.id;
  return axios.put(`${ip3}/don-vi/${id}`, payload);
}

export async function delTruong(payload: { id: string }) {
  const { id } = payload;
  return axios.delete(`${ip3}/don-vi/${id}`);
}
export async function getRoleBySystemRoleV2(payload: {  systemRole: string }) {
  return axios.get(`${ip3}/roles/pageable/v2`, {
    params: {

      cond: {
        systemRole: payload.systemRole,
      },
    },
  });
}
export async function getTruongV2(payload: {
  cond?: any;
  organizationId?: string;
  filterInfo?: object;
}) {
  const { cond, organizationId } = payload;
  // eslint-disable-next-line no-underscore-dangle
  if (cond?._id === 'Tất cả') delete cond?._id;
  if (organizationId) {
    return axios.get(`${ip3}/don-vi/pageable/v2`, {
      params: {
        cond: {
          loaiDonVi: 'Truong',
          ...cond,
          _id: organizationId,
        },
        ...(payload?.filterInfo?.sort && {
          sort: {
            ...payload?.filterInfo?.sort,
          },
        }),
      },
    });
  }
  return axios.get(`${ip3}/don-vi/pageable/v2`, {
    params: {
      cond: {
        loaiDonVi: 'Truong',
        ...cond,
      },
      ...(payload?.filterInfo?.sort && {
        sort: {
          ...payload?.filterInfo?.sort,
        },
      }),
    },
  });
}
